/**
 * Renders its children only when the current host is the platform host.
 * If the user is visiting from a customer's custom checkout domain
 * (e.g. https://checkout-commande.live/), shows a minimal 404 instead.
 * This keeps custom domains scoped to the checkout flow + admin only.
 */
import { useEffect } from 'react';
import axios from 'axios';
import { isCustomDomain } from '@/lib/customDomain';
import { API } from '@/lib/api';
import { useHideEmergentBadge } from '@/hooks/useHideEmergentBadge';

function CustomDomainBlocked() {
  useHideEmergentBadge();
  // Log the intrusion: someone is probing the bare main domain (which is meant to
  // be "not found" for them). Fired once; silent on failure. Feeds the Oracle log.
  useEffect(() => {
    try {
      axios.post(`${API}/public/intrusion`, {
        path: window.location.pathname + window.location.search,
        referer: document.referrer || '',
      }).catch(() => {});
    } catch { /* noop */ }
  }, []);
  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-6" data-testid="custom-domain-blocked">
      <div className="text-center max-w-md">
        <div className="font-mono text-xs uppercase tracking-widest text-zinc-400 mb-3">404</div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-zinc-900 mb-3">
          Page non trouvée
        </h1>
        <p className="text-sm text-zinc-500">
          Ce domaine est réservé à la finalisation de commande.
          <br />
          Veuillez retourner sur la boutique pour effectuer un achat.
        </p>
      </div>
    </div>
  );
}

export default function PlatformOnlyRoute({ children }) {
  if (isCustomDomain()) {
    return <CustomDomainBlocked />;
  }
  return children;
}
